<select2
    class="block w-full"
    [overlay]="overlay"
    [data]="vehicles()"
    [value]="value"
    [disabled]="disabled"
    [placeholder]="placeholder"
    infiniteScroll="true"
    [customSearchEnabled]="true"
    [templates]="{option: option}"
    (update)="onUpdate($event)"
    (scroll)="onScroll($event)"
    (search)="onSearch($event)">
    <ng-template #option let-label="label">
        <app-select2-option [label]="label" />
    </ng-template>
</select2>
